/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StackHDownIcon64Regular = forwardRef('StackHDownIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M22 7a1.5 1.5 0 0 0 0 3h20a1.5 1.5 0 0 0 0-3H22Z" }),
        React.createElement("path", { d: "M14.5 14.5A1.5 1.5 0 0 1 16 13h32a1.5 1.5 0 0 1 0 3H16a1.5 1.5 0 0 1-1.5-1.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 28.5a9.5 9.5 0 0 1 9.5-9.5h33a9.5 9.5 0 0 1 9.5 9.5v20a9.5 9.5 0 0 1-9.5 9.5h-33A9.5 9.5 0 0 1 6 48.5v-20Zm9.5-6.5A6.5 6.5 0 0 0 9 28.5v20a6.5 6.5 0 0 0 6.5 6.5h33a6.5 6.5 0 0 0 6.5-6.5v-20a6.5 6.5 0 0 0-6.5-6.5h-33Z" })));
});
